import { Link } from 'react-router-dom';
import { latestMovies } from '@/mocks/movies';

export default function LatestUpdates() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">每日更新，追剧不等待</p>
        </div>
        <Link
          to="/category/movie"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {latestMovies.slice(0, 8).map((movie) => (
          <Link
            key={movie.id}
            to={`/article/${movie.id}`}
            className="group block cursor-pointer"
          >
            <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
              <img
                src={movie.image}
                alt={movie.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/60 backdrop-blur-sm rounded text-xs text-yellow-400 font-semibold">
                {movie.rating}
              </div>
              <div className="absolute top-2 left-2">
                {movie.tags.includes('新番') && (
                  <span className="px-2 py-0.5 bg-accent-500 text-white text-[10px] font-medium rounded whitespace-nowrap">
                    NEW
                  </span>
                )}
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <div className="flex items-center justify-center gap-2 py-2 bg-primary-500/90 rounded-full text-white text-xs font-medium">
                  <i className="ri-play-circle-line"></i>
                  立即播放
                </div>
              </div>
            </div>
            <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
              {movie.title}
            </h3>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs text-foreground-400">{movie.category}</span>
              <span className="text-xs text-foreground-300">·</span>
              <span className="text-xs text-foreground-400">{movie.updateInfo}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}